import OmniApiClient from "./base";

export const nexaliaApi = {
  listCredentials: () => OmniApiClient.get("/nexalia/credentials/"),

  createCredentials: (payload) =>
    OmniApiClient.post("/nexalia/credentials/", payload),

  updateCredentials: (id, payload) =>
    OmniApiClient.put(`/nexalia/credentials/${id}`, payload),

  deleteCredentials: (id) => OmniApiClient.delete(`/nexalia/credentials/${id}`),

  testCredentials: (email, password) =>
    OmniApiClient.post("/nexalia/credentials/test", { email, password }),

  testStoredCredentials: (id) =>
    OmniApiClient.post(`/nexalia/credentials/${id}/test`),

  scrapeCatalog: (payload = {}) =>
    OmniApiClient.post("/nexalia/catalog/scrape", payload),

  getProducts: (
    page = 1,
    pageSize = 50,
    search = "",
    sortBy = "updated_at",
    sortOrder = "desc",
  ) =>
    OmniApiClient.get("/nexalia/products", {
      params: {
        page,
        page_size: pageSize,
        search: search || undefined,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    }),

  exportProductsCsv: (search = "", sortBy = "name", sortOrder = "asc") =>
    OmniApiClient.get("/nexalia/products/export.csv", {
      params: {
        search: search || undefined,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
      responseType: "blob",
    }),

  getCronStatus: () => OmniApiClient.get("/nexalia/cron/status"),

  startCron: (schedule) =>
    OmniApiClient.post("/nexalia/cron/start", null, {
      params: { schedule },
    }),

  stopCron: () => OmniApiClient.post("/nexalia/cron/stop"),
};
